<template>
  <div>
    <div class="task-detail-card">
      <div class="row align-items-center justify-content-between">
        <div class="col-8">
          <div class="row">
            <div class="col">
              <p class="task-detail-title">{{ dayTask.title }}</p>
              <p class="task-detail-subtitle">
                Created at: {{ formatDate(dayTask.createdDate) }}, Last Updated at:
                {{ formatDate(dayTask.updatedDate) }}
              </p>
            </div>
          </div>
        </div>
        <div class="col-auto">
          <Button
            label="View Task"
            class="qb-btn qb-btn-outline-sm"
            data-bs-toggle="collapse"
            :data-bs-target="'#collapse' + dayTask.id"
          />
        </div>
      </div>
    </div>

    <div class="collapse mb-2" :id="'collapse' + dayTask.id">
      <div class="p-2">
        <div class="card-box">
          <div class="row align-items-center my-1">
            <div class="col-12">
              <p class="task--title">Task Description:</p>
              <div class="task--description" v-html="dayTask.description"></div>

              <p class="task-detail-title">Task Type:</p>
              <Badge :label="dayTask.submissionType" class="badge-neon badge-neon-warning-outline" />
              <div class="d-flex gap-2 mt-3">
                <Button label="Edit" @onClick="edit()" class="qb-btn qb-btn-outline-sm" />
                <!-- <Button label="Delete" @onClick="deletemodal(dayTask)" class="qb-btn qb-btn-black-sm" /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Button from "../components/ButtonComponent.vue";
import Badge from "../components/BadgeComponent.vue";

export default {
  name: "ModuleTaskList",
  props: {
    index: {
      type: Number,
    },
    dayTask: {
      type: Object,
    },
    lastIndex: {
      type: Number,
    },
  },
  components: {
    Button,
    Badge,
  },
  computed: {
    // ...mapGetters({
    //   user: "getUser",
    // }),
  },
  methods: {
    showTaskPage(id) {
      this.$router.push({
        name: "ModuleDayDetailPage",
        params: { dayId: id },
      });
    },
    edit() {
      this.$emit("onEdit", this.dayTask);
    },
    deletemodal(dayTask) {
      this.$emit("showDelete", dayTask);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/color.scss";
@import "../assets/scss/font.scss";
@import "../assets/scss/field.scss";

.card-box {
  background-color: $light-fade-100;
  padding: 10px 15px;
  border-radius: $field-border-radius;
}

.icon--arrow--right {
  cursor: pointer;
}

.task--title {
  font-weight: 600;
  font-size: 14px;
  margin: 0px;
  margin-bottom: 5px;
}

.task--description {
  font-size: 14px;
}

.task-detail-card {
  background-color: $white;
  padding: 8px 12px;
  border-radius: $field-border-radius;
  margin-bottom: 10px;
  border: 1px solid $light-200;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;

  &:hover {
    background-color: #fdfdfd;
    // cursor: pointer;
  }
}

.task-detail-title {
  font-size: $font-size-md;
  font-weight: $font-weight-normal-2;
  margin-bottom: 0px;
}

.task-detail-subtitle {
  font-size: $font-size-sm;
  color: $light-600;
  font-weight: $font-weight-normal-1;
  margin-bottom: 0px;
}

.day--title {
  font-weight: 500;
  margin: 0px;
}

// .check--logo--completed {
//   filter: grayscale(0%);
//   opacity: 100%;
// }

// .check--logo--incompleted {
//   filter: grayscale(100%);
//   opacity: 30%;
// }

// .card--collapse--bottom {
//   border: 1px solid $light-100;
// }
</style>
